import { useEffect } from 'react'
import type { NextPage } from 'next'
import { useRouter } from 'next/router'

import { useCompany } from '@/hooks/useCompany'

const Company: NextPage = () => {
  const router = useRouter()
  const company = useCompany()

  useEffect(() => {
    if (company) {
      router.push(`/cash-bids`)
    }
  }, [company, router])

  return <div></div>
}

export default Company
